import { QuotationTaskSubscription } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1510. 見積タスク購読
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/quotation_task_subscriptions
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
};

const createQuotationTaskSubscription = (props: Props): Promise<QuotationTaskSubscription> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.task_id}/quotation_task_subscriptions`,
    props
  );
};

export const useCreateQuotationTaskSubscription = () => {
  return useMutation({
    mutationFn: createQuotationTaskSubscription
  });
};